<template>
    <div id="subcampaign_com">
        <div v-if="detailController.subCampaign == null">
            <div id="quantity_row">
                <div id="quantity_input_row">
                    <div id="quantity_input_wrapper">
                        <div class="quantity-icon">
                            <img src="@/assets/icon/ic-plus-circle-new.svg"
                                @click="adjustQuantity('add')" />
                        </div>
                        <div id="quantity_input">
                            <div class="input-wrapper">
                                <input
                                    id="qty_input"
                                    type="tel"
                                    v-model="selectedQuantity"
                                    :readonly="true"
                                    @input="changeQuantity()" />
                            </div>
                        </div>
                        <div class="quantity-icon">
                            <img v-if="selectedQuantity == 1" src="@/assets/icon/ic-minus-circle-enable.svg" />
                            <img v-else src="@/assets/icon/ic-minus-circle-new.svg" @click="adjustQuantity('reduce')" />
                        </div>
                    </div>
                </div>
                <div id="quantity_btn_row">
                    <redeem-button
                        :isLogin="isLogin"
                        :userPoint="userPoint"
                        :detailController="detailController"
                        :lblRedeemBTN="lbl.redeem_button"
                        @clickAddToCart="clickAddToCart()">
                    </redeem-button>
                </div>
            </div>
        </div>
        <div v-else>
            <redeem-button
                :isLogin="isLogin"
                :userPoint="userPoint"
                :detailController="detailController"
                :lblRedeemBTN="lbl.redeem_button"
                @clickAddToCart="clickAddToCart()">
            </redeem-button>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Util from '@/helper/Utility.js';
import RedeemButton from "../detail/RedeemButton.vue";
/**
 * Property
 * @property {object} lbl (required) Text for component.
 * @property {number} locale (required) Current language.
 * @property {array} subcampaign (required) Sub-campaign.
 * Event
 * @event changeColor Change selected item and setup size dropdown.
 * @event changeSize Change selected item.
 */
export default {
    name: 'AddToCart',
    props: {
        lbl: Object,
        locale: Number,
        detailController: Object,
        isLogin: Boolean,
        userPoint: Number
    },
    components: {
        RedeemButton,
    },
    data: function () {
        return {
            lblDetail: this.lbl.detail,

            haveColor: false,
            haveSize: false,
            color: [],
            size: [],
            selectedColor: null,
            selectedColorValue: '',
            selectedSize: null,
            selectedSizeValue: '',
            selectedQuantity: '1'
        };
    },
    created: function () {
        this.initialSubCampaign();
        this.changeQuantity();
    },
    methods: {
        //Event
        changeColor: function (color) {
            this.selectedColor = Util.normalObject(color);
            this.selectedColorValue = this.locale == 1033
                                ? this.selectedColor.name_en
                                : this.selectedColor.name;

            if (color.subitems && color.subitems.length > 0) {
                var size = color.subitems[0];
                if(size.value == 'none') {
                    this.size = [];
                    this.haveSize = false;

                    this.detailController.selectSubCampaign(color);
                } else {
                    this.size = Util.normalObject(color.subitems);
                    this.changeSize(size);
                    this.haveSize = true;
                }
            } else {
                this.haveSize = false;
                this.size = [];
                this.detailController.selectSubCampaign(color);
            }

            this.isLoaded = true;
        },
        changeSize: function (size) {
            this.selectedSize = size;
            this.selectedSizeValue = this.locale == 1033
                                            ? size.name_en
                                            : size.name;

            this.detailController.selectSubCampaign(size);
        },
        changeQuantity: function () {
            if (!this.selectedQuantity) return;

            var quantity = this.selectedQuantity;
            quantity = quantity.replace(Vue.RegExp.notNumber, '');

            if (quantity == 0 && quantity.length == 1)
                quantity = 1;

            if(quantity.length == 2) {
                if (quantity[0] == 0)
                    quantity = quantity.slice(1,2);
            }

            if(quantity.length > 3) {
                quantity = Util.formatNum(quantity, 0)
            }

            this.selectedQuantity = quantity;

            this.detailController.setSelectedQuantity(quantity);
        },
        adjustQuantity: function (type) {
            var quantity = parseInt(this.selectedQuantity);
            var maxQuantity = 99; 

            const redeemMostPerPerson = this.detailController.campaign.redeemMostPerPerson || maxQuantity;
            const redeemCount = this.detailController.campaign.redeemCount || 0;
            // const redeemMostPerPersonInPeriod = this.detailController.campaign.redeemMostPerPersonInPeriod || maxQuantity;
            const cooldownPeriod = this.detailController.campaign.coolDown || 0;
            const maxByPoints = Math.floor(this.userPoint / this.detailController.campaign.pointPerUnit);

            const remainingRedeemable = Math.min(
                redeemMostPerPerson - redeemCount,
                // redeemMostPerPersonInPeriod - redeemCount,
                maxByPoints,
                cooldownPeriod > 0 ? 1 : maxQuantity
            );

            if (type === 'add') {
                if (quantity < maxQuantity && quantity < remainingRedeemable) {
                    this.selectedQuantity = quantity + 1;
                }
            } else if (type === 'reduce') {
                if (quantity > 1) {
                    this.selectedQuantity = quantity - 1;
                }
            }

            // if (type == 'add') {
            //     this.selectedQuantity = quantity + 1;
            // } else {
            //     if (quantity == 1) return;

            //     this.selectedQuantity = quantity - 1;
            // }

            this.detailController.setSelectedQuantity(this.selectedQuantity);
        },
        clickAddToCart: function () {
            this.$emit('clickAddToCart', { qty: this.selectedQuantity});
        },
        //End Event
        //initial
        initialSubCampaign: function () {
            if(!this.detailController.subCampaign) return
            if (!this.detailController.subCampaign.hasStyle) return;

            this.color = this.detailController.subCampaign.styles;

            this.haveColor = true;
            this.changeColor(this.color[0]);
        }
        //End initial
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/components/Input/baseinput.scss";

#subcampaign_com {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 16px 20px;
    background-color: #ffffff;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);

    #quantity_row {
        display: flex;
        align-items: center;
        gap: 16px;
        

        #quantity_input_row {
            width: 60%;

            #quantity_input_wrapper {
                display: flex;
                align-items: center;
                width: 100%;

                .quantity-icon {
                    width: 45%;
                    margin: 0 4px;
                }

                #quantity_input {
                    @include baseRegisterInput;
                    display: inline-block;
                    width: calc(100% - 100px);
                    flex: 0 0 calc(100% - 100px);
                    margin-bottom: 0;

                    .input-wrapper {
                        input {
                            background-color: #ffffff !important;
                            border: 1px solid $a-gray-C4C4C4 !important; 
                            color: $a-gray-333333 !important;
                            height: 45px;
                            padding: {
                                left: 10px;
                                right: 10px;
                            };

                            text-align: center;
                        }
                    }
                }
            }
        }

        #quantity_btn_row {
            width: 40%;

            .btn-wrapper {
                box-shadow: none !important;
                min-height: 45px !important;

                .btn-txt {
                    font-size: 1.5rem !important;
                    font-family: $semi_bold !important;
                }
            }
        }
    }
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/components/Input/baseinput.scss";

// #subcampaign_com{
//     .subcampaign-select {
//         .ddl-input{
//             display: inline-block;
//             width: 70%;

//             .btn-ddl-input{
//                 background-image: url('../../../../assets/icon/icon_dropdown.png');
//                 background-color: #fff;
//                 background-repeat: no-repeat;
//                 background-position: center right 15px;
//                 background-size: 16px 9px;
//                 border: 1px solid $base-font-color;
//                 border-radius: 30px;
//                 width: 100%;
//                 color: $base-font-color;
//                 font-size: 1.6rem;
//                 font-family: $regular;
//                 line-height: 1;
//                 text-align: left;
//                 padding-top: 5px;
//                 padding-bottom: 5px;
//                 padding-left: 20px;
//                 padding-right: 20px;
//                 height: 50px; 
//             }

//             .dropdown-menu{
//                 font-size: 1.6rem;
//             }

//             .dropdown-item{
//                 color: $base-font-color;
//             }

//             .dropdown-toggle::after{
//                 border: none;
//             }

//         }
//     }
// }
</style>
